import styled from "styled-components";

const PARALLAX_BLEED_PX = 300;

export const BackgroundContainer = styled.div`
    position: absolute;
    top: -${PARALLAX_BLEED_PX}px;
    left: 0;
    width: 100%;
    height: calc(${props => props.height || '100%'} + ${PARALLAX_BLEED_PX * 2}px);
    background-image: url(${props => props.imageUrl});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    ${props => !props.back && 'display: none;'}
    z-index: -1;
    transition: transform 0.1s linear;
`;